import { useState, useEffect } from "react"

export const getBreakpointValue = value => {
  switch (value) {
    case "sm":
      return 640
    case "md":
      return 768
    case "lg":
      return 1024
    case "xl":
      return 1280
    default:
      return ""
  }
}

export const useToggleResponsiveContent = ({
  desktopContent,
  mobileContent,
  breakpoint,
}) => {
  const [returnValue, setReturnValue] = useState(desktopContent)

  const updateMedia = () => {
    const filteredItems =
      window.innerWidth < getBreakpointValue(breakpoint)
        ? mobileContent
        : desktopContent
    setReturnValue(filteredItems)
  }

  useEffect(() => {
    updateMedia()
    window.addEventListener("resize", updateMedia)

    return () => window.removeEventListener("resize", updateMedia)
  }, [])

  return returnValue
}

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  })
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowSize
}
